import React from "react";
import Footer from "../Footer/Footer_2";
import HomeImagePage from "../../Helpers/HomeImagePage";

const TermsCondition = () => {

  return (
    <>
    <HomeImagePage>
    
        <div className="main-terms-condition-home-page">
        <div className="terms-condition-main">
            <div className="terms-condition-contain gCDmxv">
              <h1 className="terms-condition-h1 color-white">Terms &amp; Conditions</h1>
              <p className="terms-condition-para f-size color-white">
                Kalyan, Main Bazar Jodi Chart Satta Matka Record Old History
                Historical Data Bracket Results Chart Online Live Book Digits
                Numbers
              </p>
            </div>
          </div>
          <div className="gCDmxv kDBKpC ">
              <h1 className="h1-fw-500 color-white">Withdraw Information</h1>
              <ul>
                <li>
                  <span className="span-tag-color">●</span>
                  <p className="f-size color-white">
                    If Users Entered Wrong Bank Details Bhau777 Is Not
                    Responsible.
                  </p>
                </li>
                <li>
                  <span className="span-tag-color">●</span>
                  <p className="f-size color-white">
                    Before Requesting Withdraw Re-check Your Bank Details.
                  </p>
                </li>
                <li>
                  <span className="span-tag-color">●</span>
                  <p className="f-size color-white">
                    After Withdraw Request If There Is No Vaild Wallet Balance
                    The Request Will Be Auto Declined.
                  </p>
                </li>
              </ul>
            </div>
            </div>
            </HomeImagePage>
    

        <div className="terms-condition">
      
          <div className="terms-condition-second-main">
       
            <div className="gCDmxv kDBKpC ">
              <h1 className="h1-fw-500 primary-color">Unfair - Bets</h1>
              <p className="f-size primary-color">
                If Admin Found Any Unfair-bets, Blocking Of Digits, Canning Or
                Match Fix Bets. Admin Has All Rights To Take Necessary Actions
                To Block The User.
              </p>
            </div>
            <div className="gCDmxv kDBKpC">
              <h1 className="h1-fw-500 primary-color">Cheating - Bets</h1>
              <p className="f-size primary-color">
                If Admin Found Any Cheating, Hacking, Phishing. Admin Has All
                Rights To Take Necessary Actions To Block The User.
              </p>
            </div>
          </div>
        </div>
    
      <Footer />
    </>
  );
};

export default TermsCondition;
